export default {
  token: undefined,
  enterprise: undefined,
  hosts: {
    host: 'http://dev-leadmall-c.vipzhuang.cn',
    mall: 'http://dev-leadmall.vipzhuang.cn',
    // mall: 'http://172.17.0.163:8082',
    mock: 'http://172.16.7.99:3000/mock/11'
  }
};



// WEBPACK FOOTER //
// ./src/config/dev.js